import { zUid } from "src/types/zUid";
import z from "zod";

export const zAsrtTableSettings = z.object({
  objAssortmentTable: zUid.nullable(),
  dictCollection: zUid.nullable(),
  dictDrop: zUid.optional().nullable(),
  dictCategory: zUid.optional().nullable(),
});

export type ZAsrtTableSettings = z.infer<typeof zAsrtTableSettings>;
